// Canvas Bus
// Lightweight pub-sub for cross-canvas interaction events.
// One bus per page, owned by CanvasCoordinator, replaced on Turbo navigation.
// Not a replacement for PortfolioState (data) — the bus carries transient interaction signals.
// The bus itself is intentionally dumb: no transformation, no state beyond listener dispatch.
// All intelligence lives in participants and the coordinator.

export class CanvasBus {
  constructor() {
    this._listeners = new Map()
  }

  emit(channel, payload) {
    const fns = this._listeners.get(channel)
    if (!fns) return
    for (const fn of fns) {
      try { fn(payload) } catch (e) { console.error(`[Bus] listener error on ${channel}:`, e) }
    }
  }

  on(channel, fn) {
    if (!this._listeners.has(channel)) {
      this._listeners.set(channel, new Set())
    }
    this._listeners.get(channel).add(fn)
    return () => this._listeners.get(channel)?.delete(fn)
  }

  dispose() {
    this._listeners.clear()
  }
}

// Channel Registry
// Central definition of all bus channels. Import Channels instead of using bare strings.
// New channels are added here, not invented inline in entrypoints.

export const Channels = {
  INSTRUMENT_HOVER: 'instrument:hover',
  PERIOD_HOVER: 'period:hover',
  PERIOD_SELECT: 'period:select'
}
